import { jsxs as a, jsx as o, Fragment as g } from "react/jsx-runtime";
import { z as e } from "zod";
import { withManagedProps as K } from "@made-people/managed-props";
import { withZod as f } from "@made-people/react-prop-guard";
import { miniCartLyonStyling as A } from "./index-blueprint.es.js";
import { useOverlayState as F, overlayEventEmitter as T } from "@made-people/blueprint-overlay";
import { Drawer as d } from "@made-people/blueprint-drawer";
import { cartTotalsSchema as H, cartItemsSchema as R, CartItems as G, CartTotals as U } from "@made-people/blueprint-cart-summary";
import { buttonAsLinkSchema as V, buttonAsButtonSchema as Z, Button as w } from "@made-people/blueprint-button";
import { useTranslate as J } from "@made-people/grease-translations";
import { headingSchema as X, Heading as N } from "@made-people/blueprint-heading";
import { useCartState as Y } from "@made-people/grease-cart";
import { useState as $, useCallback as D, useEffect as Q, useMemo as tt } from "react";
import "@made-people/blueprint";
const et = (s, p) => {
  let c;
  return (...m) => {
    clearTimeout(c), c = setTimeout(() => s(...m), p);
  };
}, S = e.object({
  variants: e.custom().optional(),
  trigger: e.custom().optional(),
  showCartQty: e.union([e.enum(["total_items", "total_quantity"]), e.literal(!1)]).optional(),
  template: e.literal("lyon"),
  heading: X.optional(),
  cartTotals: H.optional(),
  showCartQuantityAsSuffix: e.boolean().optional(),
  cartItems: R.optional(),
  checkoutButton: V.optional(),
  closeIcon: e.custom().optional(),
  customOverlayId: e.string().optional(),
  trustLogosBanner: e.custom().optional(),
  hasEmptyState: e.boolean().optional(),
  emptyStateButton: Z.optional(),
  direction: e.object({
    desktop: e.enum(["right", "left", "bottom"]).optional(),
    mobile: e.enum(["right", "left", "bottom"]).optional()
  }).optional(),
  miniCartUpsellContent: e.custom().optional(),
  aboveCartItemsContent: e.custom().optional()
}), ot = 768, B = K(
  "MiniCartLyon",
  f(
    {
      schema: S,
      defaultProps: {
        template: "lyon",
        direction: {
          mobile: "bottom",
          desktop: "right"
        },
        heading: {
          heading: "Mini_Cart_Header",
          variants: {
            headingSize: "2xs"
          }
        },
        checkoutButton: {
          variants: {
            width: "full"
          }
        }
      }
    },
    ({
      variants: s,
      trigger: p,
      showCartQty: c,
      cartItems: m,
      heading: t,
      checkoutButton: P,
      cartTotals: L,
      trustLogosBanner: C,
      closeIcon: k,
      hasEmptyState: W,
      emptyStateButton: x,
      customOverlayId: O,
      miniCartUpsellContent: _,
      aboveCartItemsContent: E,
      showCartQuantityAsSuffix: I
    }) => {
      const [M, z] = $(!1), i = A.styles(s), { cart: r } = Y(), n = J(), v = F(O), b = D(
        et(() => {
          z((u) => {
            const y = window.innerWidth > ot;
            return u !== y ? y : u;
          });
        }, 100),
        []
      );
      Q(() => (window.addEventListener("resize", (u) => b()), b(), () => {
        window.removeEventListener("resize", (u) => b());
      }), []);
      const l = tt(() => {
        if (!(!c || !(r != null && r.items)))
          switch (c) {
            case "total_items":
              return r.items.length;
            default:
              return r.items.reduce((u, y) => u + y.quantity, 0);
          }
      }, [c, r == null ? void 0 : r.items]), j = D(() => {
        T.emit("open", {
          overlayId: v.overlayId
        });
      }, [v.overlayId]), h = (m == null ? void 0 : m.items) ?? (r == null ? void 0 : r.items), q = ((h == null ? void 0 : h.length) === 0 || !h) && W;
      return /* @__PURE__ */ a(
        d,
        {
          customOverlayId: v.overlayId,
          hasOverlay: !0,
          hasScaledBackground: !0,
          setBackgroundColorOnScale: !1,
          variants: {
            rounded: "strong",
            background: "none",
            direction: M ? "right" : "bottom"
          },
          direction: M ? "right" : "bottom",
          children: [
            p && /* @__PURE__ */ o(d.Trigger, { onClick: j, children: p }),
            /* @__PURE__ */ a(
              d.Content,
              {
                contentSettings: {
                  "aria-description": "Mini Cart where you can see your items and total",
                  "aria-describedby": "mini-cart"
                },
                children: [
                  /* @__PURE__ */ o(d.Title, { hidden: !0, children: (t == null ? void 0 : t.heading) && n(t == null ? void 0 : t.heading) }),
                  /* @__PURE__ */ o("div", { className: i.base, children: q ? /* @__PURE__ */ a(g, { children: [
                    /* @__PURE__ */ a("div", { className: i.header, children: [
                      /* @__PURE__ */ o(
                        N,
                        {
                          suffix: I ? l == null ? void 0 : l.toString() : void 0,
                          ...t,
                          heading: (t == null ? void 0 : t.heading) && n(t == null ? void 0 : t.heading, {
                            cartQuantity: 4
                          })
                        }
                      ),
                      /* @__PURE__ */ o(d.Close, { className: i.close, children: k ?? n("Mini_Cart_Close") })
                    ] }),
                    /* @__PURE__ */ a("div", { className: i.emptyCartWrapper, children: [
                      /* @__PURE__ */ o("h3", { className: i.emptyCartMessage, children: n("Mini_Cart_EmptyState_Message") }),
                      /* @__PURE__ */ o(
                        w,
                        {
                          as: "button",
                          label: n("Mini_Cart_EmptyState_Button"),
                          onClick: () => T.emit("close", {
                            overlayId: "mini-cart"
                          }),
                          ...x
                        }
                      )
                    ] })
                  ] }) : /* @__PURE__ */ a(g, { children: [
                    /* @__PURE__ */ a("div", { className: i.cartItemsWrapper, children: [
                      /* @__PURE__ */ a("div", { className: i.header, children: [
                        /* @__PURE__ */ o(
                          N,
                          {
                            suffix: I ? l == null ? void 0 : l.toString() : void 0,
                            ...t,
                            heading: (t == null ? void 0 : t.heading) && n(t == null ? void 0 : t.heading, {
                              cartQuantity: l ?? 0
                            })
                          }
                        ),
                        /* @__PURE__ */ o(d.Close, { className: i.close, children: k ?? n("Mini_Cart_Close") })
                      ] }),
                      E && E,
                      /* @__PURE__ */ o(G, { ...m }),
                      _ && /* @__PURE__ */ o("div", { className: i.cartUpsellWrapper, children: _ })
                    ] }),
                    /* @__PURE__ */ a("div", { className: i.cartTotalsWrapper, children: [
                      /* @__PURE__ */ o(U, { ...L }),
                      C && /* @__PURE__ */ o("div", { className: i.trustLogosBannerWrapper, children: C }),
                      /* @__PURE__ */ o(
                        w,
                        {
                          as: "a",
                          context: "mini-cart",
                          label: n("Mini_Cart_Go_To_Checkout"),
                          link: { href: "checkout" },
                          ...P
                        }
                      )
                    ] })
                  ] }) })
                ]
              }
            )
          ]
        }
      );
    }
  )
), it = e.object({
  settings: S.optional()
}), St = K(
  "MiniCart",
  f(it, (s) => /* @__PURE__ */ o(B, { template: "lyon", ...s.settings }))
), rt = {
  dataModel: "with_variants",
  base: {
    slug: "product-slug",
    productId: "product-id",
    productKey: "product-key",
    discontinued: !1,
    content: {
      name: "6090",
      description: "",
      shortDescription: "",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
          alt: "Image 1"
        }
      ],
      badges: []
    },
    attributes: [],
    categories: []
  },
  variants: [
    {
      dimensions: [],
      priceInfo: {
        price: {
          formatted: "200 SEK",
          number: 200
        },
        priceWithoutDiscount: {
          formatted: "200 SEK",
          number: 200
        },
        previouslyDiscountedPrices: []
      },
      label: "variant label",
      mainProductId: "product-id",
      mainProductKey: "product-key",
      variantId: "variant-id",
      variantKey: "variant-key",
      sku: "sku",
      inventory: {
        quantity: 100,
        inStock: !0,
        warehouseId: "1"
      },
      additionalInventory: []
    }
  ],
  siblingProducts: []
}, Ct = {
  type: "product",
  lineId: "line1",
  id: "product-id",
  sku: "sku123",
  quantity: 2,
  itemDimensions: [
    {
      dimensionKey: "size",
      dimensionLabel: "Size",
      value: "M",
      valueLabel: "Medium"
    }
  ],
  price: {
    discounted: !0,
    priceEach: {
      number: 95,
      formatted: "900 SEK"
    },
    priceEachWithoutDiscount: {
      number: 100,
      formatted: "1200 SEK"
    },
    priceEachWithoutTax: {
      number: 100,
      formatted: "1200 SEK"
    },
    totalPrice: {
      number: 190,
      formatted: "1800 SEK"
    }
  },
  metaData: {
    customField: "customValue"
  },
  product: rt
}, kt = f(S, (s) => /* @__PURE__ */ o(B, { ...s }));
export {
  St as MiniCart,
  B as MiniCartLyon,
  kt as TemplateSelector,
  S as miniCartLyonSchema,
  it as miniCartPropsSchema,
  Ct as mockItem,
  et as throttle
};
//# sourceMappingURL=index.es.js.map
